import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center text-center px-6 relative overflow-hidden"
      style={{ background: '#0a0a0a' }}
    >
      {/* Background glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at 50% 40%, rgba(0,212,255,0.06) 0%, transparent 60%)' }}
      />

      {/* Big 404 */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        style={{ opacity: 0.04 }}
      >
        <span className="text-[28rem] font-black text-white leading-none">404</span>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Logo */}
        <Link to="/" className="mb-12 cursor-pointer opacity-80 hover:opacity-100 transition-opacity">
          <img
            src="https://storage.readdy-site.link/project_files/c74744eb-3995-40db-8fce-b59523b1b313/898a52d7-18aa-43c2-be1f-5134a7f25dee_ChatGPT-Image-24-mar-2026-07_22_57.png?v=a14bd4da0532dd836168e272800ed8fb"
            alt="Orsonet"
            className="h-16 w-auto object-contain"
            style={{ maxWidth: '200px' }}
          />
        </Link>

        <div
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#00d4ff]/30 bg-[#00d4ff]/5 mb-8"
        >
          <span className="text-[#00d4ff] text-xs font-semibold tracking-widest uppercase">Strona nie znaleziona</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-black text-white mb-4">
          Ups, zabłądziłeś
        </h1>

        <p className="text-white/40 text-lg max-w-md mb-3 leading-relaxed">
          Strona <span className="text-white/60 font-mono text-sm">{location.pathname}</span> nie istnieje.
        </p>
        <p className="text-white/30 text-base mb-10">
          Może szukasz czegoś z naszej oferty?
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 text-black px-8 py-4 rounded-xl font-bold text-base whitespace-nowrap cursor-pointer hover:scale-105 transition-transform shadow-[0_0_30px_rgba(0,212,255,0.3)]"
            style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
          >
            <i className="ri-home-3-line" />
            Wróć na stronę główną
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center gap-2 text-white/70 hover:text-white px-8 py-4 rounded-xl font-bold text-base whitespace-nowrap cursor-pointer border border-white/15 hover:border-white/30 transition-all"
          >
            Skontaktuj się z nami
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Quick links */}
        <div className="mt-14 flex flex-wrap gap-3 justify-center">
          {[
            { to: '/uslugi', label: 'Usługi' },
            { to: '/realizacje', label: 'Realizacje' },
            { to: '/pakiety', label: 'Pakiety' },
            { to: '/blog', label: 'Blog' },
            { to: '/o-nas', label: 'O nas' },
          ].map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="px-4 py-2 rounded-lg text-sm text-white/35 hover:text-white/70 border border-white/8 hover:border-white/20 transition-all cursor-pointer"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
